export default class CraftingController {
  constructor(game, location, recipes) {
    this.game = game;
    this.location = location;
    this.recipes = recipes;

    this.onCraft = new Phaser.Signal();
  }

  checkItems(items) {
    items = items.concat(); // make copy of items
    // console.log(items);

    // get all items from stacks if the stack is on items list
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === 'stack') {
        const stack = items.splice(i, 1)[0];
        i--;
        this.addItemsFromStack(stack, items);
      }
    }

    for (const key in this.recipes) {
      if (this.recipes.hasOwnProperty(key)) {
        const recipe = this.recipes[key];
        for (let i = 0; i < recipe.length; i++) {
          const result = this.checkRecipe(recipe[i], items);
          if (result) {
            result.id = key; // set new item id
            return result;
          }
        }
      }
    }

    return null;
  }

  addItemsFromStack(stack, items) {
    for (let i = 0; i < stack.items.length; i++) {
      const stackItem = stack.items[i];
      if (items.indexOf(stackItem) < 0) {
        // no item on list - add it
        items.push(stackItem);
      }
    }
  }

  checkRecipe(recipe, items) {
    recipe = recipe.concat();
    let firstItemUsed = false; // first item in the list is item drop by user
    const toRemove = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const ind = recipe.indexOf(item.id);
      if (ind > -1) {
        if (i === 0 || item.id === 'stack') {
          firstItemUsed = true;
        }
        // if item is not unlimited, remove it
        if (!item.hasFlag('unlimited')) {
          toRemove.push(item);
        }
        recipe.splice(ind, 1);
      }
    }

    //
    if (recipe.length === 0 && firstItemUsed) {
      // all items are available
      return { toRemove };
    } else {
      // not all items - nothing crafted
      return null;
    }
  }
}
